export const APP_BASE_PATH = '/tcmsuiV2';
export const APP_PORT = 3000;
export const APP_RELEASE_VERSION = '2023.10.1.0';
export const APP_API_VERSION = 'v1';
export const APP_BUILD_TIME = '4/18/2024, 3:02:32 PM'; // Do not edit this line